/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {FlagTypePipe as ɵa} from './lib/flag-type.pipe';